import { Button } from "react-bootstrap";

import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";

export default function AccordionCustomButton({
  children,
  eventKey,
  className,
  as,
  style,
}) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Button
      onClick={decoratedOnClick}
      className={className}
      as={as}
      style={style}
      variant="light"
    >
      {children}
    </Button>
  );
}

export function AccordionCardHeader({ children, eventKey, className }) {
  const decoratedOnClick = useAccordionButton(eventKey);

  return (
    <Card.Header
      onClick={decoratedOnClick}
      className={className}
      as="h4"
      role="button"
    >
      {children}
    </Card.Header>
  );
}
